import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  activeIndex: number | null = null;

  faqs = [
    {
      q: "What programs do Shah Satnam Ji Girls' College offer?",
      a: "Shah Satnam Ji Girls' College offers a range of undergraduate and postgraduate programs in various disciplines including arts, science, commerce, and more."
    },
    {
      q: "How do I apply for admission to Shah Satnam Ji Girls' College?",
      a: "You can apply for admission by visiting our website and filling out the online application form. Alternatively, you can visit the college campus and complete the admission process in person."
    },
    {
      q: "What are the eligibility criteria for admission?",
      a: "The eligibility criteria vary depending on the program you are applying for. Generally, students must have completed their Secondary education for undergraduate and Graduation for Postgraduate with a minimum percentage or grade as specified by the college."
    },
    {
      q: "Does the college provide any scholarships or financial aid?",
      a: "Yes, Shah Satnam Ji Girls' College offers scholarships and financial assistance to eligible students. Details about the scholarships and how to apply for them can be found on our website or by contacting the college administration."
    },
    {
      q: "What facilities are available on campus?",
      a: "Our campus is equipped with state-of-the-art facilities including well-equipped classrooms, laboratories, a library, sports facilities, hostel accommodations, and more."
    },
    {
      q: "Is there any provision for extracurricular activities?",
      a: "Yes, we encourage students to participate in extracurricular activities such as sports, cultural events, community service, and more. These activities help in overall personality development."
    },
    {
      q: "Are there any opportunities for internships or practical training?",
      a: "Yes, Shah Satnam Ji Girls' College facilitates internships and practical opportunities for students to gain real-world experience in their chosen field of study."
    },
    {
      q: "How can I get in touch with the college administration for further inquiries?",
      a: "You can contact us through the contact information provided on our website or visit the college in person during working hours."
    },
    {
      q: "Does Shah Satnam Ji Girls' College offer skill-oriented courses or vocational training programs?",
      a: "Yes, in addition to traditional academic programs, we also offer skill-oriented courses and vocational training programs designed to enhance students' employability and practical skills in various fields."
    },
    {
      q: "What are the hostel facilities like?",
      a: "Our college provides a safe and comfortable hostel (Balika Ashram) accommodation for students coming from outstation areas. This Balika Ashram has facilities like furnished rooms, mess services, recreational areas, and 24/7 security."
    },
    {
      q: "Is transportation provided for students?",
      a: "Yes, the college provides transportation facilities for students commuting to and from the campus. The transport service covers various routes within the vicinity of Sirsa and nearby villages for the convenience of our students."
    },
    {
      q: "Does the College organize educational tours or field trips?",
      a: "Yes, Shah Satnam Ji Girls' College organizes educational tours and field trips to enrich student's learning experiences and provide them with practical exposure to their subjects of study. These trips are organized periodically and are often related to the curriculum."
    },
    {
      q: "What kind of sports and recreational facilities are available on campus?",
      a: "Our college boasts a range of sports and recreational facilities including outdoor and indoor sports facilities, a gymnasium, a yoga centre, and spaces for cultural activities and events."
    },
    {
      q: "Are there any clubs or student organizations on campus?",
      a: "Yes, Shah Satnam Ji Girls' College has various clubs and student organizations catering to different interests such as literary clubs, cultural clubs, NSS, NCC, YRC, RED RIBBON, Environmental clubs, and more. Students are encouraged to join these clubs to explore their interests and talents."
    },
    {
      q: "How does the college support students' career development and placement opportunities?",
      a: "The college has a dedicated placement cell that facilitates career counselling, skill development workshops, and placement opportunities for students. We collaborate with leading companies and organizations to provide placement assistance to our students."
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  toggleFAQ(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

}


